module.exports = __webpack_public_path__ + "img/boat10.0f9dd1c3.png";